import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="70"
      height="70"
      viewBox="0 0 70 70"
      fill="none"
    >
      <g clipPath="url(#clip0_6007_4791)">
        <path
          d="M56.9404 0H48.1221L34.8945 9.92065L39.0695 13.0484C39.5724 12.9037 40.0546 12.6626 40.4818 12.3457L56.9404 0Z"
          fill="#1C6543"
        />
        <g filter="url(#filter0_d_6007_4791)">
          <path
            d="M12.5068 11.1689V59.6699C12.5068 62.1018 14.4841 64.079 16.916 64.079H52.1894C54.6214 64.079 56.5986 62.1018 56.5986 59.6699V11.1689C56.5986 8.73701 54.6214 6.75977 52.1894 6.75977H16.916C14.4841 6.75977 12.5068 8.73701 12.5068 11.1689ZM45.5757 15.5781H23.5298C22.3104 15.5781 21.3252 14.5929 21.3252 13.3735C21.3252 12.1541 22.3104 11.1689 23.5298 11.1689H45.5757C46.7951 11.1689 47.7802 12.1541 47.7802 13.3735C47.7802 14.5929 46.7951 15.5781 45.5757 15.5781Z"
            fill="url(#paint0_linear_6007_4791)"
          />
          <path
            d="M12.7868 59.6699V11.1689C12.7868 8.89165 14.6387 7.03977 16.916 7.03977H52.1894C54.4667 7.03977 56.3186 8.89165 56.3186 11.1689V59.6699C56.3186 61.9472 54.4667 63.799 52.1894 63.799H16.916C14.6387 63.799 12.7868 61.9472 12.7868 59.6699ZM23.5298 15.8581H45.5757C46.9497 15.8581 48.0602 14.7476 48.0602 13.3735C48.0602 11.9995 46.9497 10.8889 45.5757 10.8889H23.5298C22.1557 10.8889 21.0452 11.9995 21.0452 13.3735C21.0452 14.7476 22.1557 15.8581 23.5298 15.8581Z"
            stroke="url(#paint1_linear_6007_4791)"
            stroke-opacity="0.8"
            strokeWidth="0.56"
          />
        </g>
        <mask
          id="mask0_6007_4791"
          style={{ maskType: "alpha" }}
          maskUnits="userSpaceOnUse"
          x="12"
          y="6"
          width="45"
          height="59"
        >
          <rect
            x="12.7969"
            y="6.6001"
            width="43.5124"
            height="57.6245"
            fill="#D9D9D9"
          />
        </mask>
        <g mask="url(#mask0_6007_4791)">
          <path
            d="M35.191 22.5103C36.2532 21.9959 37.4957 22.0116 38.5446 22.5526L58.5187 32.8557C61.1777 34.2273 61.2387 38.0075 58.6253 39.464L35.4397 52.3865C34.2924 53.026 32.894 53.0186 31.7536 52.3669L11.2267 40.6373C8.60755 39.1406 8.73775 35.3211 11.4528 34.0063L35.191 22.5103Z"
            stroke="white"
            stroke-opacity="0.2"
            strokeWidth="0.5"
          />
        </g>
        <g filter="url(#filter1_d_6007_4791)">
          <path
            d="M21.6074 0H12.7891L29.2546 12.3457C29.6817 12.6626 30.1571 12.9037 30.6669 13.0484C31.0596 13.1655 31.4661 13.2206 31.8794 13.2275H37.7767C38.1969 13.2275 38.6103 13.1655 39.0099 13.0484L21.6074 0Z"
            fill="#B9F5D9"
          />
        </g>
        <path
          d="M35.6741 28.6524C35.9574 28.5152 36.2887 28.5194 36.5684 28.6636L50.5366 35.8687C51.2456 36.2345 51.2619 37.2425 50.565 37.6309L34.7528 46.4439C34.4468 46.6144 34.0739 46.6124 33.7698 46.4386L19.443 38.2519C18.7445 37.8527 18.7792 36.8342 19.5032 36.4836L35.6741 28.6524Z"
          fill="#1C6543"
          fill-opacity="0.3"
        />
        <path
          d="M25.4829 29.6446C25.5648 29.6446 25.6445 29.6647 25.7152 29.7038L27.4359 30.6535V34.9905C27.4358 35.0664 27.4539 35.1411 27.4888 35.2086C27.5237 35.276 27.5743 35.3342 27.6364 35.3782C27.6985 35.4222 27.7703 35.4507 27.8457 35.4614C27.9212 35.4721 27.9981 35.4646 28.0701 35.4396L28.7772 35.1961C28.8749 35.1625 28.9837 35.1961 29.0466 35.2776L30.132 36.7233C30.1919 36.8035 30.2757 36.8628 30.3715 36.8928C30.4673 36.9228 30.5701 36.922 30.6654 36.8904C30.7607 36.8588 30.8435 36.7982 30.9021 36.717C30.9607 36.6358 30.9921 36.5383 30.9917 36.4384V32.6164L33.3937 33.9425C34.1143 34.3403 34.9898 34.3403 35.7093 33.9425L43.3889 29.7038C43.4616 29.6635 43.5436 29.6428 43.6268 29.6437C43.71 29.6447 43.7915 29.6673 43.8632 29.7093C43.9349 29.7513 43.9943 29.8113 44.0356 29.8832C44.0768 29.9552 44.0984 30.0366 44.0982 30.1194V35.0329C44.0982 35.9021 43.6212 36.7021 42.8535 37.1177L35.6947 41.0033C34.9819 41.3888 34.1222 41.3888 33.4094 41.0033L26.2506 37.1177C25.8741 36.9135 25.5598 36.6122 25.3408 36.2453C25.1218 35.8785 25.0061 35.4597 25.0059 35.0329V30.1194C25.0059 29.8569 25.2191 29.6446 25.4829 29.6446ZM35.6969 19.2389L46.5283 25.1221C46.6412 25.1834 46.7354 25.2739 46.801 25.384C46.8667 25.4941 46.9013 25.6197 46.9013 25.7478C46.9013 25.8758 46.8667 26.0014 46.801 26.1115C46.7354 26.2216 46.6412 26.3121 46.5283 26.3734L35.6969 32.2567C35.3461 32.4473 34.9529 32.5473 34.5532 32.5473C34.1535 32.5473 33.7602 32.4473 33.4094 32.2567L22.5781 26.3734C22.4652 26.3121 22.371 26.2216 22.3053 26.1115C22.2397 26.0014 22.2051 25.8758 22.2051 25.7478C22.2051 25.6197 22.2397 25.4941 22.3053 25.384C22.371 25.2739 22.4652 25.1834 22.5781 25.1221L33.4094 19.2389C33.7602 19.0482 34.1535 18.9482 34.5532 18.9482C34.9529 18.9482 35.3461 19.0482 35.6969 19.2389Z"
          fill="url(#paint2_linear_6007_4791)"
          fill-opacity="0.9"
        />
        <path
          d="M20.6241 51.8765L21.0945 52.9502H20.2198L19.7907 51.8765H20.6241ZM22.5055 51.8765L22.9263 52.9502H22.0764L21.6969 51.8765H22.5055ZM24.7252 53.144C24.9948 53.144 25.1873 53.1951 25.3028 53.2974C25.4238 53.3996 25.4844 53.553 25.4844 53.7575C25.4844 53.8275 25.4816 53.8813 25.4761 53.919L25.3771 54.7506H24.5519L24.6674 53.8706H19.9228L19.8155 54.7506H18.9821L19.0893 53.8625C19.1223 53.6095 19.1966 53.4265 19.3121 53.3135C19.4277 53.2005 19.6092 53.144 19.8567 53.144H23.4462L24.1146 51.8926H24.9645L24.3291 53.144H24.7252ZM21.5318 58.9164C21.1302 58.8626 20.6929 58.7549 20.2198 58.5934L20.3271 57.8184C20.8112 57.9906 21.1522 58.0929 21.3503 58.1252H21.3915C21.4686 58.1252 21.5208 58.0875 21.5483 58.0122L21.6886 56.8254H18.6768L18.7675 56.1069H21.7794L21.8041 55.905L22.9676 55.1542H20.096L20.1786 54.4518H23.6772C23.8588 54.4518 23.9963 54.4868 24.0898 54.5568C24.1888 54.6268 24.2384 54.7156 24.2384 54.8232C24.2384 55.0062 24.1366 55.1704 23.933 55.3157L22.7696 56.1069H25.5009L25.4101 56.8254H22.5303L22.3322 58.4078C22.2992 58.5854 22.2332 58.7172 22.1342 58.8034C22.0407 58.8895 21.9031 58.9325 21.7216 58.9325C21.6831 58.9325 21.6198 58.9271 21.5318 58.9164Z"
          fill="#196240"
        />
        <path
          d="M31.2852 51.9007L31.1367 53.2409H33.5544L33.4719 53.9917H31.0625L30.8974 55.4933H33.1996L33.1171 56.236H30.8232L30.6334 57.9799H33.5957L33.5049 58.7468H26.8129L26.9036 57.9799H29.8L29.9815 56.236H27.6958L27.7866 55.4933H30.064L30.2208 53.9917H28.3807L28.2734 54.2419C28.2239 54.3496 28.1634 54.4841 28.0919 54.6456C28.0259 54.8017 27.9681 54.9282 27.9186 55.025H27.0192C27.2337 54.5676 27.4647 54.0482 27.7123 53.4669C27.8608 53.1171 28.0176 52.6972 28.1826 52.2075H29.0656L28.8923 52.6999C28.8648 52.7914 28.796 52.9717 28.686 53.2409H30.2951L30.4436 51.9007H31.2852Z"
          fill="#196240"
        />
        <path
          d="M40.197 53.6768C40.3015 54.6671 40.5216 55.5713 40.8571 56.3894C41.1707 57.1429 41.6025 57.8695 42.1526 58.5692L41.3687 58.8518C41.0332 58.4427 40.7334 57.9449 40.4693 57.3582C40.1888 56.7662 39.966 56.1365 39.8009 55.4691C39.5809 56.1472 39.2948 56.7904 38.9428 57.3986C38.5962 58.0068 38.2221 58.5019 37.8205 58.8841L36.9954 58.6096C37.617 58.066 38.1506 57.3206 38.5962 56.3733C38.7887 55.9589 38.9483 55.5364 39.0748 55.1058C39.2068 54.6698 39.3003 54.2554 39.3553 53.8625L39.6029 52.0056H40.4115L40.197 53.6768ZM35.8979 52.0783L37.7215 52.7807L37.606 53.6041L35.7906 52.9018L35.8979 52.0783ZM36.6323 57.0676C36.6268 57.0837 36.6241 57.1026 36.6241 57.1241C36.6241 57.1456 36.6351 57.1564 36.6571 57.1564C36.6791 57.1564 36.7093 57.1456 36.7478 57.1241C37.0559 56.9626 37.3749 56.7527 37.705 56.4944L37.8123 57.3179C37.4767 57.5654 37.1301 57.7861 36.7726 57.9799C36.5855 58.0875 36.415 58.1413 36.261 58.1413C36.162 58.1413 36.0794 58.1171 36.0134 58.0687C35.8704 57.9772 35.7989 57.8184 35.7989 57.5924C35.7989 57.5493 35.8044 57.4793 35.8154 57.3825L36.1785 54.7102H35.1635L35.2543 53.9513H36.5415C36.7066 53.9513 36.8276 53.9944 36.9046 54.0805C36.9816 54.1612 37.0119 54.2769 36.9954 54.4276L36.6323 57.0676Z"
          fill="#196240"
        />
        <path
          d="M44.0835 52.0379L45.7503 52.7484L45.6348 53.5638L43.9763 52.8533L44.0835 52.0379ZM46.295 52.3366H50.429L50.3548 53.0875H49.084L48.853 54.904H50.165L50.0742 55.6467H48.7622L48.4651 57.9395H50.264L50.1897 58.7065H45.3543L45.4368 57.9395H46.0392L46.5012 54.2419H47.2934L46.8313 57.9395H47.64L48.2588 53.0875H46.2124L46.295 52.3366ZM44.8097 57.1806V57.1968C44.8097 57.2452 44.8262 57.2694 44.8592 57.2694C44.8702 57.2694 44.8922 57.2587 44.9252 57.2371C45.2773 56.9519 45.5606 56.7151 45.7751 56.5267L45.8576 57.4228C45.5606 57.665 45.258 57.8884 44.9499 58.0929C44.7739 58.2113 44.6061 58.2705 44.4466 58.2705C44.3751 58.2705 44.3008 58.2517 44.2238 58.214C44.0588 58.1225 43.9763 57.961 43.9763 57.7296C43.9763 57.6973 43.9818 57.6381 43.9928 57.552L44.3558 54.7021H43.3739L43.4646 53.9594H44.6941C44.8592 53.9594 44.9857 54.0051 45.0737 54.0966C45.1617 54.1881 45.1947 54.3065 45.1727 54.4518L44.8097 57.1806Z"
          fill="#196240"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_6007_4791"
          x="7.50684"
          y="3.75977"
          width="54.0918"
          height="67.3193"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0783854 0 0 0 0 0.100868 0 0 0 0 0.145833 0 0 0 0.62 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_6007_4791"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_6007_4791"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_6007_4791"
          x="10.7891"
          y="0"
          width="30.2207"
          height="17.2275"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0433333 0 0 0 0 0.133333 0 0 0 0 0.0910257 0 0 0 0.16 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_6007_4791"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_6007_4791"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_6007_4791"
          x1="34.553"
          y1="6.60028"
          x2="34.5527"
          y2="64.079"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5DC293" />
          <stop offset="1" stopColor="#7BB8B4" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_6007_4791"
          x1="14.5608"
          y1="8.07029"
          x2="54.8392"
          y2="63.3428"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9AEBC5" />
          <stop offset="1" stopColor="#86CBAB" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_6007_4791"
          x1="24.8894"
          y1="18.9482"
          x2="45.3656"
          y2="42.0784"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.333333" stopColor="#DEEFE7" />
          <stop offset="1" stopColor="#E1F3EB" stop-opacity="0.38" />
        </linearGradient>
        <clipPath id="clip0_6007_4791">
          <rect width="70" height="70" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Icon;
